import "node_modules/reset-css/reset.css";
import "node_modules/prosemirror-view/style/prosemirror.css";
import "node_modules/prosemirror-tables/style/tables.css";
import "node_modules/prosemirror-gapcursor/style/gapcursor.css";

import "Content/styles/app/action-icons.less";
import "Content/styles/app/branding.less";
import "Content/styles/app/css-colors.less";
import "Content/styles/app/custom-error-pages.less";
import "Content/styles/app/fonts.less";
import "Content/styles/app/general-styles.less";
import "Content/styles/app/global-variables-mixins.less";
import "Content/styles/app/headers.less";
import "Content/styles/app/layout.less";
import "Content/styles/app/media-queries.less";
import "Content/styles/app/public-pages.less";
import "Content/styles/app/scrollbar.less";
import "Content/styles/app/spacings.less";
import "Content/styles/app/workarounds.less";

import "Content/styles/app/components/app-color.less";
